module.exports = __webpack_public_path__ + "img/jtys.0b011a9e.svg";